import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { ProgressBar } from "../../ProgressBar.js";
import { Spinner } from "../../Spinner.js";
import { useClassNamePrefix } from "../../../auxiliary/useClassNamePrefix.js";
const defaultFormatProgressMessage = (progress) => `Uploading${progress === void 0 ? "" : ` (${(progress * 100).toFixed()}%)`}`;
const UploadProgress = ({
  progress,
  formatProgressMessage = defaultFormatProgressMessage
}) => {
  const prefix = useClassNamePrefix();
  const renderNumericProgress = (progress2) => {
    const clampedProgress = Math.max(0, Math.min(progress2 ?? 0, 1));
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("div", { className: `${prefix}uploadProgress-progress`, children: /* @__PURE__ */ jsx(ProgressBar, { progress: clampedProgress }) }),
      /* @__PURE__ */ jsxs("div", { className: `${prefix}uploadProgress-message`, children: [
        /* @__PURE__ */ jsx("div", { className: `${prefix}uploadProgress-message-stabilizer`, children: formatProgressMessage(1) }),
        /* @__PURE__ */ jsx("div", { className: `${prefix}uploadProgress-message-real`, children: formatProgressMessage(clampedProgress) })
      ] })
    ] });
  };
  const renderStringProgress = (progress2) => /* @__PURE__ */ jsx("div", { className: `${prefix}uploadProgress-message`, children: progress2 });
  return /* @__PURE__ */ jsxs("div", { className: `${prefix}uploadProgress`, children: [
    (progress === void 0 || typeof progress === "string") && /* @__PURE__ */ jsx("div", { className: `${prefix}uploadProgress-indeterminate`, children: /* @__PURE__ */ jsx(Spinner, {}) }),
    typeof progress === "number" && renderNumericProgress(progress),
    typeof progress === "string" && renderStringProgress(progress)
  ] });
};
UploadProgress.displayName = "UploadProgress";
export {
  UploadProgress
};
//# sourceMappingURL=UploadProgress.js.map
